import styled from 'styled-components';
import Chip from 'components/Chip';
import { th } from 'style/theme';

export const PlanType = styled.div`
  display: inline-block;
  padding: 4px 8px;
  border-radius: 8px;
  font-weight: 500;
  color: ${th('colors.pickledBluewood')};
  background-color: ${th('colors.confetti')};
`;

export const ChipWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const AddonChip = styled(Chip)`
  display: flex;
  align-items: center;
  padding: 6px 12px;
  background-color: ${th('colors.fountainBlue+3')};
  color: ${th('colors.pickledBluewood')};

  > img {
    width: 25px;
    height: 25px;
    margin-top: -3px;
  }
`;
